export enum PublicEventSsoAttribute {
  Undefined = 0,
  UserId = 1,
  FirstName = 2,
  LastName = 3,
  Email = 4,
  LanguageId = 5
}
